module.exports = __webpack_public_path__ + "media/images/graphwear-afdd63f6.png";